import React from 'react';

/**
 * Card — базовая карточка BetMate.
 *
 * @param {'base'|'interactive'|'glass'} variant
 * @param {string} className
 * @param {function} onClick — если передан, карточка становится кликабельной
 */
const ACTIVATION_KEYS = new Set(['Enter', ' ']);
const INTERACTIVE_CHILD_SELECTOR = 'a, button, input, select, textarea, [role="button"], [role="link"], [tabindex]';

const Card = ({
  children,
  variant = 'base',
  className = '',
  onClick,
  onKeyDown,
  role,
  tabIndex,
  ...rest
}) => {
  const isInteractive = variant === 'interactive' || !!onClick;
  const isClickable = typeof onClick === 'function';

  const classes = [
    variant === 'glass' ? 'bm-card--glass' : 'bm-card',
    isInteractive ? 'bm-card--interactive' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const handleKeyDown = (event) => {
    if (onKeyDown) {
      onKeyDown(event);
    }

    const target = event.target;
    const isNestedInteractiveElement = target !== event.currentTarget
      && target instanceof Element
      && target.closest(INTERACTIVE_CHILD_SELECTOR);

    if (
      !isClickable
      || event.defaultPrevented
      || !ACTIVATION_KEYS.has(event.key)
      || isNestedInteractiveElement
    ) {
      return;
    }

    event.preventDefault();
    onClick(event);
  };

  return (
    <div
      className={classes}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={role || (isClickable ? 'button' : undefined)}
      tabIndex={tabIndex ?? (isClickable ? 0 : undefined)}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;
